/* global dataLayer */
import { activityLoggerService } from './ActivityLoggerService';
import $ from 'jquery';

export default {
    init() {
        // Bind filter options
        $(document).on('click', '.block-keukenfilters td > label', function () {
            let checkbox = $(this).parent('td').find('input:checkbox');
            if (!checkbox.prop('checked')) {
                let label = $(this).text();
                activityLoggerService.logConfiguratorActivity({ 'ActivityCodeName': 'KeukenDetail.FilterFront', 'ActivityTitle': `Filter '${label}' applied`, 'ActivityValue': label });

                // Log Google Analytics
                dataLayer.push({
                    'event': 'FilterApplied',
                    'detail': {
                        'ActivityCodeName': 'FilterApplied',
                        'ActivityTitle': `Filter '${label}' applied`,
                        'ActivityValue': label
                    }
                });
            }
        });
    }
};



// WEBPACK FOOTER //
// ./CMS/scripts/modules/KeukenDetailActivityLogger.js